// extracted by mini-css-extract-plugin
export default {"search-box":"SearchBox_search-box__zIBtd"};